import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../interceptors/PublicInterceptor";

// OBTENER TODAS LOS PAISES
export const obtenerCountries = async () => {
  const respuesta = await PrivateInterceptor(`Base/Global/Countries`, "GET");
  return respuesta;
};

// AGREGAR PAIS
export const addCountry = async (data) => {
  const respuesta = await PrivateInterceptor(
    `Base/Global/Countries/add`,
    "POST",
    data
  );
};

// OBTIENER LISTADO DE BANCOS
export const getCountriesList = async(Token) => {
  const result = await PublicInterceptor('Base/Global/Countries/token', 'GET', {}, Token)
  return result;
}
